import React from 'react';
import { history, connect } from 'umi';

// import cl from 'classnames';
import { Navigation } from '@digitalc/dxp-ui';
import { goBack } from '@/utils/utils';
// import { getDeviceType } from '@/utils/utilsPoint';
import styles from './index.less';

// import leftImg from '@/assets/images/point/icon-left.png';
// import deleteImg from '@/assets/images/point/delete.png';

const Header = props => {
  const { title, goHome, notNewPage } = props;

  const { needGoBackByApp } = history.location.query;

  const handleGoBack = () => {
    if (needGoBackByApp) {
      goBack();
    } else if (notNewPage) {
      history.goBack();
    } else if (goHome) {
      goHome();
    } else {
      history.goBack();
    }
  };

  // 右上角X号统一返回H5首页
  // const handleGoHome = () => {
  //   window.localStorage.setItem('tabIndex', JSON.stringify(0));
  //   window.clp.goBackHome();
  // };

  return (
    <Navigation
      title={title}
      goBack={handleGoBack}
      rightIcons={[]}
      className={styles.headerWrap}
      noRight
    />
    // <header className={cl(styles.header, className, { [styles.androidHeader]: getDeviceType() === 'android' })}>
    //   <img onClick={handleGoBack} src={leftImg} alt="" />
    //   <h3 title={title}>{title} </h3>
    //   {/* {searchText && <p onClick={handelopenSearch}>{searchText}</p>} */}
    //   {/* <span onClick={handleGoHome} className={styles.close}><img alt="" src={deleteImg} /></span> */}
    //   <span />
    // </header>
  );
};

export default connect()(Header);
